import { takeLatest, put, select } from 'redux-saga/effects'
import { Types } from '../ducks/patrimony'
import { graphClient } from './auth'
import { notifyError, notifySuccess } from '../../utils/notify'

function* getTiSolicitations() {
  try {
    const userEmail = yield select(state => state.auth.user.mail)
    const siteId = 'ecossissolucoes.sharepoint.com,bb5a5629-a926-45be-95d1-114aeba768e8,3cbf2f69-8c01-4ccf-b52b-214414b00e37'
    const listId = '3ab107dd-407e-41a0-9080-186e78fe6558'
    const endpoint = `sites/${siteId}/lists/${listId}/items?$expand=fields`

    const res = yield graphClient.api(endpoint).get()
    const data = res.value.filter(i => i.createdBy.user.email === userEmail)
    console.tron.log('getTiSolicitations data', data)

    yield put({
      type: Types.GET_TI_SOLICITATIONS_SUCCEEDED,
      payload: data,
    })
  } catch (err) {
    console.tron.log(err)
    notifyError('Não foi possível carregar os chamados de TI.')
    yield put({
      type: Types.GET_TI_SOLICITATIONS_FAILED,
    })
  }
}

function* postTiSolicitation(action) {
  try {
    const data = action.payload
    const siteId = 'ecossissolucoes.sharepoint.com,bb5a5629-a926-45be-95d1-114aeba768e8,3cbf2f69-8c01-4ccf-b52b-214414b00e37'
    const listId = '3ab107dd-407e-41a0-9080-186e78fe6558'
    const endpoint = `/sites/${siteId}/lists/${listId}/items`

    const res = yield graphClient.api(endpoint).post({
      fields: {
        Title: data.patrimony,
        Prioridade: data.priority.value,
        DescrevasuaDemanda: data.description,
        PrazodeAtendimentoDesejado: data.endDate,
        TipodeDemanda: data.subject.value,
      },
    })

    console.tron.log('postTiSolicitation res', res)

    notifySuccess('Chamado aberto com sucesso.')

    yield put({ type: Types.POST_TI_SOLICITATION_SUCCEEDED })
  } catch (err) {
    console.tron.log(err)
    notifyError('Não foi possível criar este chamado de TI. Tente novamente mais tarde.')
    yield put({
      type: Types.POST_TI_SOLICITATION_FAILED,
    })
  }
}

function* getPurchAndMaintenanceSolicitations() {
  try {
    const userEmail = yield select(state => state.auth.user.mail)
    const siteId = 'ecossissolucoes.sharepoint.com,bb5a5629-a926-45be-95d1-114aeba768e8,3cbf2f69-8c01-4ccf-b52b-214414b00e37'
    const listId = '418e73fc-96aa-4dd3-9938-47893a5830e1'
    const endpoint = `sites/${siteId}/lists/${listId}/items?$expand=fields`

    const res = yield graphClient.api(endpoint).get()
    const data = res.value.filter(i => i.createdBy.user.email === userEmail)
    console.tron.log('getPurchAndMaintenanceSolicitations data', data)

    yield put({
      type: Types.GET_PURCH_AND_MAINTENANCE_SOLICITATIONS_SUCCEEDED,
      payload: data,
    })
  } catch (err) {
    console.tron.log(err)
    notifyError('Não foi possível carregar a lista. Tente novamente mais tarde.')
    yield put({
      type: Types.GET_PURCH_AND_MAINTENANCE_SOLICITATIONS_FAILED,
    })
  }
}

function* postPurchAndMaintenanceSolicitation(action) {
  try {
    const data = action.payload
    const siteId = 'ecossissolucoes.sharepoint.com,bb5a5629-a926-45be-95d1-114aeba768e8,3cbf2f69-8c01-4ccf-b52b-214414b00e37'
    const listId = '418e73fc-96aa-4dd3-9938-47893a5830e1'
    const endpoint = `/sites/${siteId}/lists/${listId}/items`

    const res = yield graphClient.api(endpoint).post({
      fields: {
        Priority: data.priority.value,
        Setor: data.sector.value,
        Title: data.subject,
        Detalhamento: data.description,
        Valor: data.value,
        Formadepagamento: data.payment,
      },
    })

    console.tron.log('postPurchAndMaintenanceSolicitation res', res)

    notifySuccess('Solicitação enviada com sucesso.')

    yield put({ type: Types.POST_PURCH_AND_MAINTENANCE_SOLICITATION_SUCCEEDED })
  } catch (err) {
    console.tron.log(err)
    notifyError('Não foi possível enviar a solicitação. Tente novamente mais tarde.')
    yield put({
      type: Types.POST_PURCH_AND_MAINTENANCE_SOLICITATION_FAILED,
    })
  }
}

export const patrimonySagas = [
  takeLatest(Types.GET_TI_SOLICITATIONS_REQUESTED, getTiSolicitations),
  takeLatest(Types.POST_TI_SOLICITATION_REQUESTED, postTiSolicitation),
  takeLatest(Types.GET_PURCH_AND_MAINTENANCE_SOLICITATIONS_REQUESTED, getPurchAndMaintenanceSolicitations),
  takeLatest(Types.POST_PURCH_AND_MAINTENANCE_SOLICITATION_REQUESTED, postPurchAndMaintenanceSolicitation),
]
